"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInstagramCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 512C0 229.2 229.2 0 512 0s512 229.2 512 512-229.2 512-512 512S0 794.8 0 512zm512-273.1c-74.2 0-83.5.3-112.6 1.6s-48.9 5.9-66.3 12.7a139.72 139.72 0 00-79.9 79.9c-6.8 17.4-11.4 37.2-12.7 66.3s-1.6 38.4-1.6 112.6.3 83.4 1.6 112.6c1.3 29.2 5.9 48.9 12.7 66.3 14.2 36.7 43.2 65.7 79.9 79.9 17.4 6.8 37.2 11.4 66.3 12.7s38.4 1.6 112.6 1.6 83.4-.3 112.6-1.6c29.2-1.3 48.9-5.9 66.3-12.7 36.7-14.2 65.7-43.2 79.9-79.9 6.7-17.4 11.3-37.2 12.7-66.3 1.4-29.1 1.6-38.4 1.6-112.6s-.3-83.5-1.6-112.6-6-48.9-12.7-66.3a139.72 139.72 0 00-79.9-79.9c-17.4-6.8-37.3-11.4-66.3-12.7s-38.4-1.6-112.6-1.6zm-24.5 49.2H512c72.9 0 81.6.3 110.3 1.6 26.6 1.2 41.1 5.7 50.7 9.4 23.8 9.2 42.6 28 51.8 51.8 3.7 9.6 8.2 24.1 9.4 50.7 1.3 28.8 1.6 37.4 1.6 110.3s-.3 81.5-1.6 110.3c-1.2 26.6-5.7 41.1-9.4 50.7-9.2 23.8-28 42.6-51.8 51.8-9.6 3.8-24.1 8.2-50.7 9.4-28.8 1.3-37.4 1.6-110.3 1.6s-81.6-.3-110.3-1.6c-26.6-1.2-41.1-5.7-50.7-9.4-23.8-9.2-42.6-28-51.8-51.8-3.7-9.6-8.2-24.1-9.4-50.7-1.3-28.8-1.6-37.4-1.6-110.4s.3-81.5 1.6-110.3c1.2-26.6 5.7-41.1 9.4-50.7 9.2-23.8 28-42.6 51.8-51.8 9.6-3.8 24.1-8.2 50.7-9.4 26.6-1.2 35-1.5 85.8-1.5zm170.3 45.3c-18.1 0-32.8 14.7-32.8 32.8 0 18.1 14.7 32.8 32.8 32.8s32.8-14.7 32.8-32.8c0-18.1-14.7-32.8-32.8-32.8zM512 371.8c-77.4 0-140.2 62.8-140.2 140.2S434.6 652.2 512 652.2 652.2 589.4 652.2 512c0-37.2-14.8-72.8-41.1-99.1s-61.9-41.1-99.1-41.1zm0 49.2c50.3 0 91 40.7 91 91s-40.7 91-91 91-91-40.7-91-91 40.7-91 91-91z"
  }));
}

var ForwardRef = React.forwardRef(SvgInstagramCircle);
var _default = ForwardRef;
exports.default = _default;